import Ashti from '../assets/images/ashti.png'
import Pme from '../assets/images/pme.png'
import Loading from '../assets/images/loading.jpg'
import { CapacitorIcon,
  TypescriptIcon,

  NodeIcon,
  MongoIcon,
  IonicIcon,

  FirebaseIcon,

  AndroidIcon,

  ReactIcon, 
  HtmlIcon,

CssIcon,
JavascriptIcon,
} from '../assets/svg/index'
const projectData = [
    {
      label:"Capstone Project",
      title:"Ashti Grocery Store",
      description: "Ashti's Store Application is a comprehensive Inventory Management System tailored specifically for the efficient operation of Ashti Grocery Store. Developed as a capstone project, this cutting-edge system combines Ionic React, Capacitor, and Firebase technologies to provide seamless functionality and enhanced user experience. With its key features QR and Barcode Scanning, Filtering and Category Management and Expiration Tracking with Notifications.The Application is Available in Web App and Android.",
      image: Ashti,
      url:"https://nexust.slarenasitsolutions.com/",
      icon:[
        <IonicIcon/>,  
        <TypescriptIcon/>,   
        <AndroidIcon/>,   
        <FirebaseIcon/>,
        <CapacitorIcon />,
         <ReactIcon/>, 
      ]
    },
    {
      label:"Internship Project",
      title:"BulSU PMES",
      description: "BulSU PMES is a system to assess and improve the performance of individual offices and departments within an organization of Bulacan State University. I managed the development of back-end features for both the administrative and user functionalities. This encompassed tasks such as database management, server-side scripting, and system integration to ensure smooth operation. Additionally, I played a role in enhancing the functionality of the front-end. This comprehensive approach to system development facilitated seamless integration and optimization, ultimately leading to an enhanced user experience.BulSU ",
      image: Pme,
      url:"https://pdo-bulsupmes.web.app/",
      icon:[
        <NodeIcon/>,
        <MongoIcon/>,
        <FirebaseIcon/>,
        <CssIcon/>,
        <JavascriptIcon/>,
        <HtmlIcon />,
             <ReactIcon/>, 
      ]
    },
    {
      label:"Personal Project",
      title:"Personal Portfolio",
      description: "Embark on a journey through my skills and project portfolio with this interactive web application built using React.js and Node.js. As a passionate developer, I've crafted this platform to not only showcase my technical proficiency but also to provide a glimpse into the innovative projects I've undertaken.",
      image: Loading,
      url:"",
      icon:[
        <NodeIcon/>,
        <CssIcon/>,
        <JavascriptIcon/>,
        <HtmlIcon />,
             <ReactIcon/>, 
      ]
    },
    {
      label:"Coming Soon Project",
      title:"Coming Soon",
      description: "Lorem ipsum dolor sit am Lorem ipsum dolor sit amet, consectetur adip non proident, sed do eiusmod tempor incididunt ut labore",
      image: Loading,
      url:"",
      icon:[
        <CssIcon/>,
        <JavascriptIcon/>,
        <HtmlIcon/>,
      ]
    },
    {
      label:"Coming Soon Project",
      title:"Coming Soon",
      description: "Lorem ipsum dolor sit am Lorem ipsum dolor sit amet, consectetur adip non proident, sed do eiusmod tempor incididunt ut labore",
      image: Loading,
      url:"",
      icon:[
        <CssIcon/>,
        <JavascriptIcon/>,
        <HtmlIcon/>,
      ]
    },
    {
      label:"Coming Soon Project",
      title:"Coming Soon",
      description: "Lorem ipsum dolor sit am Lorem ipsum dolor sit amet, consectetur adip non proident, sed do eiusmod tempor incididunt ut labore",
      image: Loading,
      url:"",
      icon:[
        <CssIcon/>,
        <JavascriptIcon/>,
        <HtmlIcon/>,
      ]
    },
  ];
  
  export default projectData;
  